export const LANDING_PAGE_URL = 'https://vizion.space';

export const ROUTE_MAP = {
  overview: {
    id: 'tong-quan',
    label: 'Tổng quan The Win City',
  },
  'floor-plan': {
    id: 'mat-bang-tang',
    label: 'Mặt bằng tầng',
  },
  masterplan: {
    id: 'so-do-tong-the',
    label: 'Sơ đồ tổng thể',
  },
  interior: {
    id: 'can-ho',
    label: 'Căn hộ',
  },
  neighborhood: {
    id: 'lien-ket-vung',
    label: 'Liên kết vùng',
  },
  amenities: {
    id: 'tien-ich',
    label: 'Tiện ích',
  },
};

export const SCENE_IDS = {
  main_view: '68e768a4fa4f187e528e21c2',
  studio: '68fafb7ae62230d4b4453d49',
  '1bedroom': '68fadb0abeb5aead0ada1c6b',
  '2pn': '68fafb04e62230d4b4453c85',
  '3pn': '68faffe9e62230d4b44540ff',
};
